import type { ReduxAction, WelcomeGuideState } from '@repo/utils/types';

const initialWelcomeGuideState = {
  visible: false,
};

export function welcomeGuideReducer(
  state: WelcomeGuideState = initialWelcomeGuideState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'TOGGLE_WELCOME_GUIDE_VISIBILITY':
      return { visible: payload };

    default:
      return state;
  }
}
